import logo from '@/assets/logo/logo-icon.png'

export const pushNotification = (message:string) => {
    if (Notification.permission === "granted") {
      const notification = new Notification("New Notification", {
        body: message || "You have a new notification",
        icon: logo, // Optional: Add an icon
      });
  
      notification.onclick = () => {
        window.focus(); 
      };
    }
  };
